var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#D6E6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8542 21.3593L19.942 25.3447C20.8748 25.9807 22.0196 26.2775 23.122 26.1079C24.2667 25.9807 25.2843 25.3871 25.9627 24.4968L26.2171 24.1576C27.0227 23.0128 27.2771 21.5712 26.8107 20.2145C26.5139 19.4089 26.0475 18.6881 25.3267 18.1793L20.2388 14.1938L14.8542 21.3593Z",
    fill: "#1D64C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04458 11.2678L8.79019 11.5646C7.94221 12.7094 7.73022 14.1933 8.19661 15.5501C8.451 16.3557 8.95979 17.034 9.63817 17.5852L14.3444 21.1043L19.6443 13.9389L14.9804 10.4198C13.1149 8.97826 10.4013 9.35985 9.04458 11.2678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMedicine);
export default __webpack_public_path__ + "static/media/addMedicine.9890f45c7a8752d9a985444c4a2c3d9e.svg";
export { ForwardRef as ReactComponent };